import {
  StyleSheet,
  ImageBackground,
  useWindowDimensions,
  SafeAreaView,
  Image,
} from "react-native";
import React from "react";
import {
  Heading,
  Text,
  ScrollView,
  Box,
  View,
  Pressable,
  VStack,
} from "native-base";
import { LinearGradient } from "expo-linear-gradient";
import Card, { CardProps } from "../../components/Card";
import { StackScreenProps } from "../../types";
import BottomSlidingImages from "../../components/BottomSlidingImages";
import Header from "../../components/Header";

const Index = ({ navigation }: StackScreenProps<"ResearchAndDev">) => {
  const { width, height } = useWindowDimensions();

  const data: CardProps[] = [
    {
      heading: "Crop Research",
      subheading: "Over $30Billion Investment",
      details:
        "OCP has invested over $30Billion to develop 16 speciality fertilizer formulas for 8 Crops in partnership with Local Research institutes",
      iconName: "",
      onPress: () => navigation.navigate("CropResearch"),
      image: require("../../assets/vectors/plant.png"),
    },
    {
      heading: "Soil Research",
      subheading: "$22Million Research samples",
      details:
        "OCP has conducted soil research covering samples from about 22Million ha in partnership with Nigerian Institute of Soil Science. ",
      iconName: "",
      onPress: () => navigation.navigate("SoilResearch"),
      image: require("../../assets/vectors/search.png"),
    },
  ];

  const partners = [
    { image: require("../../assets/iart.png"), name: "IAR&T" },
    { image: require("../../assets/niss.png"), name: "NISS" },
    { image: require("../../assets/fmard.png"), name: "FMARD" },
    { image: require("../../assets/iita.png"), name: "IITA" },
    { image: require("../../assets/crin.png"), name: "CRIN" },
    {
      image: require("../../assets/nihort.png"),
      name: "NIHORT",
      color: "#659935",
    },
    { image: require("../../assets/nifor.png"), name: "NIFOR" },
  ];

  return (
    <ImageBackground
      source={require("../../assets/background.png")}
      resizeMode="repeat"
      style={{ width, height, backgroundColor: "#6A3F24ca" }}
    >
      <Box style={styles.overlay}>
        <SafeAreaView style={{ height }}>
          <ScrollView
            contentContainerStyle={{
              justifyContent: "space-between",
              flex: 1,
            }}
          >
            <View>
              <Header
                onPress={() => navigation.navigate("Home")}
                headingText="Research & Development"
                intro="OCP Africa is broadly involved in soil and crop research with the aim of provisioning farmers with ecologically sound, environmentally friendly, and agriculturally sustainable products for improving their productivity and livelihood."
              />
              <View justifyContent="center" mt={10} mb={10} px={5}>
                {data.map((item) => (
                  <Pressable key={item.heading} mb={10} onPress={item.onPress}>
                    <Card
                      heading={item.heading}
                      subheading={item.subheading}
                      details={item.details}
                      iconName={item.iconName}
                      onPress={item.onPress}
                      image={item?.image}
                      bg="#6A3F24"
                    />
                  </Pressable>
                ))}
              </View>
            </View>

            <View>
              <Text textAlign="center" mb={3}>
                Some of OCP Local Research Partners are{" "}
              </Text>

              <BottomSlidingImages partners={partners} />
            </View>
          </ScrollView>
        </SafeAreaView>
      </Box>
    </ImageBackground>
  );
};

export default Index;

const styles = StyleSheet.create({
  shadow: {
    shadowOffset: { width: 0, height: 20 },
    shadowRadius: 20,
    shadowOpacity: 0.6,
    shadowColor: "#000000",
    elevation: 20,
  },
  overlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: "rgba(26,5,7,0.1)",
  },
});
